import * as utilsTypes from './utilsTypes';
import cloneDeep from 'lodash.clonedeep';
import { REQUEST_STATUS } from 'src/constants/constants';

const initState = {
  drawerState: {
    left: {
      open: false,
      anchor: 'left',
    },
    right: {
      open: false,
      anchor: 'right',
    },
  },
  notifications: [],
  history: [],
  requests: {
    INBOX_LOADING: {
      requestStatus: REQUEST_STATUS.SUCCESS,
    },
    SENT_LOADING: {
      requestStatus: REQUEST_STATUS.SUCCESS,
    },
    DRAFT_LOADING: {
      requestStatus: REQUEST_STATUS.SUCCESS,
    },
  },
};

const utilsReducer = (state = initState, action) => {
  switch (action.type) {
    case utilsTypes.TOGGLE_DRAWER: {
      let res = cloneDeep(state);

      res.drawerState[action.anchor].open = action.payload;

      return res;
    }

    case utilsTypes.SHOW_NOTIFICATION:
      return {
        ...state,
        notifications: [{ ...action.notification }, ...state.notifications],
      };

    case utilsTypes.REMOVE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.filter(notification => notification.index !== action.index),
      };

    case utilsTypes.ADD_TO_HISTORY:
      return {
        ...state,
        history: [...state.history, { url: action.url, params: action.params }],
      };

    case utilsTypes.ADD_REQUEST:
      return {
        ...state,
        requests: { ...state.requests, [action.requestId]: { requestStatus: action.requestStatus } },
      };

    case utilsTypes.UPDATE_REQUEST:
      return {
        ...state,
        requests: { ...state.requests, [action.requestId]: { requestStatus: action.requestStatus } },
      };

    default: {
      return state;
    }
  }
};

export { initState };
export default utilsReducer;
